/*
 * TVF Wholesale Value block
 * Recomputes reseller figures (pieces, price/item, est. resale, profit, markup)
 * from three sources:
 *   - the selected variant price (grade/style variants)
 *   - the KaChing bundle tier (quantity + discount) via window.kachingBundlesApi
 *   - product metafields base_pieces + resale_value_per_piece (rendered into data-* attrs)
 * Falls back to the base tier (qty 1, no discount) when KaChing is absent.
 */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    var pattern = format || '${{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var frac = parts[1] ? decimal + parts[1] : '';
      return dollars + frac;
    }

    var match = pattern.match(placeholderRegex);
    var placeholder = match ? match[1] : 'amount';
    var value;
    switch (placeholder) {
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' ', ''); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return pattern.replace(placeholderRegex, value);
  }

  function parseMoneyToCents(str) {
    if (!str) return null;
    var cleaned = str.replace(/[^0-9.,]/g, '');
    if (!cleaned) return null;
    // If both separators exist, the last one is the decimal separator.
    var lastDot = cleaned.lastIndexOf('.');
    var lastComma = cleaned.lastIndexOf(',');
    var decPos = Math.max(lastDot, lastComma);
    var intPart, fracPart;
    if (decPos > -1 && cleaned.length - decPos <= 3) {
      intPart = cleaned.slice(0, decPos).replace(/[.,]/g, '');
      fracPart = cleaned.slice(decPos + 1).replace(/[.,]/g, '');
    } else {
      intPart = cleaned.replace(/[.,]/g, '');
      fracPart = '';
    }
    var num = parseFloat(intPart + '.' + (fracPart || '0'));
    return isNaN(num) ? null : Math.round(num * 100);
  }

  function initBlock(root) {
    var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
    var basePieces = parseInt(root.getAttribute('data-base-pieces'), 10);
    var resaleCents = parseFloat(root.getAttribute('data-resale-cents'));
    var section = root.getAttribute('data-section');
    var fallbackPrice = parseFloat(root.getAttribute('data-base-price'));
    var showProfit = root.getAttribute('data-show-profit') === 'true';

    if (!basePieces || basePieces < 1 || !resaleCents || resaleCents <= 0) return;

    // Map of variantId -> { p: priceCents, r: resaleCentsPerPiece } (resale resolved
    // variant-level first, product-level fallback, in Liquid).
    var variants = {};
    try { variants = JSON.parse(root.getAttribute('data-variants') || '{}'); } catch (e) {}

    var form = document.querySelector('#product-form-' + section) ||
               document.querySelector('form[action*="/cart/add"]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;

    var out = {};
    root.querySelectorAll('[data-wv]').forEach(function (el) { out[el.getAttribute('data-wv')] = el; });

    function currentVariant() {
      var id = idInput && idInput.value ? idInput.value : root.getAttribute('data-variant-id');
      return (id && variants[id]) ? variants[id] : null;
    }
    function currentBasePrice() {
      var v = currentVariant();
      return (v && v.p != null) ? v.p : fallbackPrice;
    }
    function currentResaleCents() {
      var v = currentVariant();
      return (v && v.r) ? v.r : resaleCents;
    }

    // KaChing deals are static per page — fetch once and reuse.
    var dealsPromise = null;
    function getDeals() {
      if (!window.kachingBundlesApi || !window.kachingBundlesApi.fetchDeals) return Promise.resolve(null);
      if (!dealsPromise) dealsPromise = window.kachingBundlesApi.fetchDeals().catch(function () { return null; });
      return dealsPromise;
    }

    function selectedTier() {
      var selectedEl = document.querySelector('.kaching-bundles__bar--selected');
      if (!selectedEl) return Promise.resolve({ qty: 1, disc: 0, totalCents: null });
      var barId = selectedEl.getAttribute('data-deal-bar-id');
      return getDeals().then(function (deals) {
        if (!deals) return { qty: 1, disc: 0, totalCents: null };
        for (var i = 0; i < deals.length; i++) {
          var bars = deals[i].dealBars || [];
          for (var j = 0; j < bars.length; j++) {
            if (bars[j].id === barId) {
              var d = bars[j].discount;
              var disc = (d && d.type === 'percentage') ? d.value / 100 : 0;
              var result = { qty: bars[j].quantity || 1, disc: disc, totalCents: null };
              // Non-percentage discount (rare here): read the price KaChing renders.
              if (d && d.type !== 'percentage') {
                result.totalCents = parseMoneyToCents(
                  (selectedEl.querySelector('.kaching-bundles__bar-price') || {}).textContent
                );
              }
              return result;
            }
          }
        }
        return { qty: 1, disc: 0, totalCents: null };
      });
    }

    function set(key, text) { if (out[key]) out[key].textContent = text; }

    function update() {
      var basePrice = currentBasePrice();
      var resalePerPiece = currentResaleCents();
      selectedTier().then(function (t) {
        var items = basePieces * t.qty;
        var totalCents = t.totalCents != null ? t.totalCents : Math.round(basePrice * t.qty * (1 - t.disc));
        var perItemCents = Math.round(totalCents / items);
        var resaleTotal = Math.round(items * resalePerPiece);
        var profit = resaleTotal - totalCents;

        set('items', items.toLocaleString());
        set('peritem', formatMoney(perItemCents, moneyFormat));
        set('resale', formatMoney(resaleTotal, moneyFormat));
        if (showProfit) set('profit', (profit >= 0 ? '+' : '') + formatMoney(profit, moneyFormat));
      });
    }

    // Debounce so a burst of mutations triggers one recompute.
    var pending = null;
    function scheduleUpdate() {
      if (pending) clearTimeout(pending);
      pending = setTimeout(update, 80);
    }

    // 1. KaChing radios fire a native change on selection.
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.name && t.name.indexOf('kaching-bundles-deal') === 0) scheduleUpdate();
    });

    // 2. Variant change (grade/style) updates the hidden id input.
    if (idInput) idInput.addEventListener('change', scheduleUpdate);

    // 3. Watch the KaChing widget: it renders async and can re-render.
    var attempts = 0;
    (function watch() {
      var container = document.querySelector('.kaching-bundles') ||
                      document.querySelector('[class*="kaching-bundles__bars"]');
      if (!container) {
        if (attempts++ < 40) setTimeout(watch, 400); // give the app up to ~16s to mount
        return;
      }
      new MutationObserver(scheduleUpdate).observe(container, {
        childList: true, subtree: true, attributes: true, attributeFilter: ['class']
      });
      scheduleUpdate();
    })();

    // Initial sync (Liquid already rendered the base tier, so no empty flash).
    scheduleUpdate();
  }

  function init() {
    document.querySelectorAll('[data-wv-root]').forEach(initBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
